<template>
  <div>
    <q-r-code :value="coupon.qrCode" style="margin: 24px auto auto;"/>
    <h4 style="text-align: center;" class="heading py4">{{ $t("cms.coupon.QRCodeModalTitle") }}</h4>
    <hr style="width: 250px;"/>
    <p
      class="mb4 mt2 gray"
      style="text-align: center"
    >{{ $t("cms.coupon.QRCodeModalSubtitle") }}</p>
  </div>
</template>

<script>
import QRCode from '@/components/cta/QRCode.vue';

export default {
  name: 'QRCodeModal',
  components: { QRCode },
  props: {
    coupon: { type: Object, required: true },
  },
};
</script>
